// export const DEFAULT_MAP_CENTER = [6.959484, 79.857045];
export const DEFAULT_MAP_CENTER = [6.955428, 79.856062];

